import React from "react";
import { Label, Input } from "@/components/form";
import { formatUrl, validateUrl } from "../validation";

interface WebsiteFieldProps {
  id?: string;
  name?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  className?: string;
}

const WebsiteField: React.FC<WebsiteFieldProps> = ({
  id = "website",
  name = "website",
  value,
  onChange,
  onBlur,
  label = "Website",
  placeholder = "https://www.example.com",
  required = false,
  error = false,
  hint,
  className = "",
}) => {
  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Don't auto-format while typing - we'll do it on blur
    onChange(e);
  };

  const handleUrlBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const formattedUrl = formatUrl(e.target.value);
    
    // Only update if the formatting changed the value
    if (e.target.value !== formattedUrl) {
      // Create a change event with the formatted URL
      const inputEvent = {
        target: {
          name: e.target.name,
          value: formattedUrl,
          id: e.target.id
        }
      } as React.ChangeEvent<HTMLInputElement>;
      
      onChange(inputEvent);
    }
    
    // Validate the URL
    const validationResult = validateUrl(formattedUrl, required);
    
    // Call the provided onBlur if exists
    if (onBlur) {
      // Create a new event with the formatted value for onBlur
      const newBlurEvent = {
        ...e,
        target: {
          ...e.target,
          value: formattedUrl
        }
      } as React.FocusEvent<HTMLInputElement>;
      
      onBlur(newBlurEvent);
    }
  };

  return (
    <div className={className}>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      <Input
        id={id}
        name={name}
        type="url"
        placeholder={placeholder}
        value={value}
        onChange={handleUrlChange}
        onBlur={handleUrlBlur}
        error={!!error}
        hint={typeof error === 'string' ? error : hint}
        required={required}
      />
    </div>
  );
};

export default WebsiteField; 